export default {
  message: {},
  alertFlag: false,
  errorAlertFlag: false,
  errorMessage: ''
}
